import React from 'react';
import { useTranslation } from 'react-i18next';
import AssistantHistoryRemoveAlert from '../../../../components/Alert/Assistant/AssistantHistoryRemoveAlert.component';
import IconButtonComponent from '../../../../components/IconButton.component';
import TrashIcon from '../../../../components/Icons/Trash.icon';
import TooltipComponent from '../../../../components/Tooltip.component';
import { useAppDispatch } from '../../../../hooks/useAppDispatcher.hook';
import { useModalManager } from '../../../../hooks/ModalManager.hook';
import { deleteAssistantHistoryThunk } from '../../../../redux/Assistant/Assistant.thunk';
import { ALERT_ACTION_ENUM } from '../../../../types/action.types';
import {
  canDeleteAssistantHistoryMessage,
  getAssistantHistoryIdFromMessageId,
} from '../../../../utils/assistant.utils';
import {
  StyledAssistantMessageDelete,
  StyledAssistantTooltipWrapper,
} from '../Assistant.styles';

interface AssistantMessageDeleteButtonProps {
  messageId: string;
}

const AssistantMessageDeleteButton = ({
  messageId,
}: AssistantMessageDeleteButtonProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { openModal } = useModalManager();
  const historyId = getAssistantHistoryIdFromMessageId(messageId);

  if (!historyId || !canDeleteAssistantHistoryMessage(messageId)) {
    return null;
  }

  const handleConfirm = (action?: ALERT_ACTION_ENUM) => {
    if (!action || action !== ALERT_ACTION_ENUM.YES) {
      return;
    }

    dispatch(deleteAssistantHistoryThunk(historyId));
  };

  return (
    <StyledAssistantMessageDelete>
      <StyledAssistantTooltipWrapper>
        <IconButtonComponent
          mode="transparent"
          aria-label={t('assistant.deleteMessage')}
          onClick={(event: React.MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();
            openModal(AssistantHistoryRemoveAlert, {
              handleConfirm,
            });
          }}
        >
          <TrashIcon />
        </IconButtonComponent>
        <TooltipComponent tooltip={t('assistant.deleteMessage')} />
      </StyledAssistantTooltipWrapper>
    </StyledAssistantMessageDelete>
  );
};

export default AssistantMessageDeleteButton;
